import { colorVariables } from './colorVariables';

export const theme = {
  colors: colorVariables,
};
